module.exports = __webpack_public_path__ + "img/ahorcadoNuevo.693f9c9c.png";